<template>
  <div class="home">
    <div class="home--top">
      <IndicateurTdb />
      <cards-layout
        cardsType="Tâches"
        :cards="cardsListTaches"
      />
    </div>

    <div class="home--sub">
      <cards-layout
        v-for="(section, cardType) in homeCardsSubSections"
        :key="cardType"
        :cardsType="cardType"
        :cards="section?.cards?.value"
        :redirection="section?.onClick"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import IndicateurTdb from './components/indicateurTdb/IndicateurTdb.vue'
  import CardsLayout from '@/features/interface/home/components/cardsLayout/CardsLayout.vue'
  import { useHomeCardMapping } from './useHomeCardMapping'

  const { homeCardsSubSections, cardsListTaches } = useHomeCardMapping()
</script>

<style scoped lang="less">
  @import './HomeView.less';
</style>
